<template>
  <v-card flat class="setup-subtab-content">
    <div>
      <div class="font-weight-bold">
        {{ $t('bigDeal.annualCost') }}
      </div>
      <div>
        {{ $t('bigDeal.annualCostDescription') }}
      </div>

      <div>

        <v-list-item class="setting-list-item">
          <v-list-item-icon>
            <v-icon v-if="!publisherBigDealCost" color="error">mdi-close-outline</v-icon>
            <v-icon v-if="publisherBigDealCost" color="success">mdi-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="text-h5">
              <span v-if="publisherBigDealCost">
                {{ publisherBigDealCost | currency(publisherCurrencySymbol) }}
              </span>
              <span v-if="!publisherBigDealCost">
                {{ $t('common.notSet') }}
              </span>
            </div>
            <div class="body-2">
              {{ $t('bigDeal.annualCostLabel') }}
            </div>

          </v-list-item-content>
          <v-list-item-action class="align-self-start">
            <v-btn fab small @click="openCostDialog" color="primary" class="" elevation="2">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

      </div>

      <div class="font-weight-bold mt-12">
        {{ $t('bigDeal.annualCostIncrease') }}
      </div>
      <div>
        {{ $t('bigDeal.annualCostIncreaseDescription') }}
      </div>

      <div>
        <v-list-item class="setting-list-item">
          <v-list-item-icon>
            <v-icon v-if="!publisherIsBigDealCostIncreaseDefined" color="error">mdi-close-outline</v-icon>
            <v-icon v-if="publisherIsBigDealCostIncreaseDefined" color="success">mdi-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="text-h5">
              <span v-if="publisherIsBigDealCostIncreaseDefined">
                {{ publishersBigDealCostIncrease | percent(2) }}
              </span>
              <span v-if="!publisherIsBigDealCostIncreaseDefined">
                {{ $t('common.notSet') }}
              </span>
            </div>
            <div class="body-2">
              {{ $t('bigDeal.annualIncrease') }}
            </div>

          </v-list-item-content>
          <v-list-item-action class="align-self-start">
            <v-btn fab small @click="openIncreaseDialog" color="primary" class="ml-5" elevation="2">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>


      <div class="font-weight-bold mt-12">
        {{ $t('bigDeal.fiveYearAnnualCost') }}
      </div>
      <div>
        {{ $t('setup.fiveYearCostDescription') }}
      </div>

      <div>
        <v-list-item class="setting-list-item">
          <v-list-item-icon>
            <v-icon v-if="!publisherBigDeal5YearAnnualCost" color="warning">mdi-alert</v-icon>
            <v-icon v-if="publisherBigDeal5YearAnnualCost" color="success">mdi-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="text-h5">
              <span v-if="publisherBigDeal5YearAnnualCost">
                {{ publisherBigDeal5YearAnnualCost | currency(publisherCurrencySymbol) }}
              </span>
              <span v-if="!publisherBigDeal5YearAnnualCost">
                {{ $t('common.unknown') }}
              </span>
            </div>
            <div class="body-2">
              {{ $t('bigDeal.fiveYearLabel') }}
            </div>

          </v-list-item-content>
        </v-list-item>
      </div>


    </div>


    <!--            DIALOGS                                          -->
    <!--*****************************************************************-->


    <v-dialog
        persistent
        v-model="dialogs.cost"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          {{ $t('bigDeal.editBigDealCost') }}
        </v-card-title>
        <div class="pa-6">
          <v-text-field
              v-model="newVal"
              :label="$t('bigDeal.annualCostInput', { currency: publisherCurrency })"
              outlined
              placeholder="1000000"
              type="number"
              :prefix="publisherCurrencySymbol"
              @keydown.enter="setBigDealData"
          />
        </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              depressed
              :disabled="isLoading"
              @click="cancelDialogs"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              depressed
              color="primary"
              :loading="isLoading"
              @click="setBigDealData"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        persistent
        v-model="dialogs.increase"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          {{ $t('bigDeal.editBigDealCostIncrease') }}
        </v-card-title>
        <div class="pa-6">
          <v-text-field
              v-model="newVal"
              :label="$t('bigDeal.annualIncreaseInput')"
              outlined
              placeholder="1.8"
              type="number"
              append-icon="mdi-percent"
              @keydown.enter="setBigDealData"
          />
        </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              depressed
              :disabled="isLoading"
              @click="cancelDialogs"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              depressed
              color="primary"
              :loading="isLoading"
              @click="setBigDealData"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {api} from "@/api";


export default {
  name: "PublisherSetupTabBigDealCosts",
  components: {
  },
  props: {},
  data() {
    return {
      isLoading: false,
      currency: "USD",
      dialogIsShowing: false,
      currencyValueBeforeDialog: null,
      currencyLastValue: null,
      increaseValue: 0,
      newVal: 0,


      dialogs: {
        cost: false,
        increase: false,
      }
    }
  },
  methods: {
    cancelDialogs() {
      this.dialogs.cost = false
      this.dialogs.increase = false
    },
    openCostDialog() {
      this.dialogs.cost = true
      this.newVal = this.publisherBigDealCost
    },
    openIncreaseDialog() {
      this.dialogs.increase = true
      this.newVal = this.publishersBigDealCostIncrease
    },

    createPostData() {
      if (this.dialogs.cost) {
        return {cost_bigdeal: this.newVal}
      } else {
        return {cost_bigdeal_increase: this.newVal}
      }
    },

    async setBigDealData() {
      console.log("setBigDealData()")
      this.isLoading = true
      const path = `publisher/${this.publisherId}`
      const postData = this.createPostData()
      try {
        await api.postFile(path, postData)
        await this.$store.dispatch("refreshPublisher")
        this.$store.commit("snackbar", this.$t('bigDeal.editSuccessful'))
      } catch (e) {
        console.log("there was an error.")
      } finally {
        this.cancelDialogs()
        this.isLoading = false
      }
    }
  },
  computed: {
    ...mapGetters([
      "publisherId",
      "publisherWarnings",
      "publisherCurrency",
      "publisherBigDealCost",
      "publishersBigDealCostIncrease",
      "publisherIsBigDealCostIncreaseDefined",
      "publisherCurrencyIconName",
      "publisherCurrencySymbol",
      "publisherBigDeal5YearAnnualCost",
        "publisherPublisher"
    ]),
  },
  created() {
  },
  mounted() {
    this.currency = this.publisherCurrency
  },
  watch: {
    currency: function (to, from) {
      this.currencyLastValue = from
    }
  }
}
</script>

<style scoped lang="scss">
.setting-list-item {
  max-width: 300px;
}


</style>
